// IMPORTS

// External Libraries
import { defineStore } from 'pinia';

// Type - Read models
import type {
  ParentDashboardReadModel,
  ChildDetailsReadModel
} from '@c1/dashboard.types.read-models';

interface ParentDashboardStoreState {
  /**
   * All children of the parent user.
   */
  children?: ParentDashboardReadModel['children'];

  /**
   * Child details by ID
   */
  [key: string]:
    | ChildDetailsReadModel
    | ParentDashboardReadModel['children']
    | undefined;
}

export const useParentDashboardStore = defineStore('ParentDashboard', {
  // Internal state. Initialised as EMPTY
  state: (): ParentDashboardStoreState => ({}),
  /**
   * Store Getters
   */
  getters: {
    isLoaded: (state) => !!state.children
  },

  actions: {
    /**
     * Load the store from external callers.
     */
    async load(
      parentDashboardStoreState: ParentDashboardStoreState['children']
    ) {
      // Update children sent by external pages/components in the store
      this.children = parentDashboardStoreState;
    },
    // Load child data into the store
    loadChildData: function (
      childUserID: string,
      childData: ChildDetailsReadModel
    ) {
      Object.assign(this, { [childUserID]: childData });
    },
    updateIsChildNewLearner: function (
      childUserID: string,
      isNewUser: boolean
    ) {
      if (this[childUserID]) {
        this[childUserID].isNewUser = isNewUser;
      }
    },
    // Clear child data from the store
    clearChildData: function (childUserID: string) {
      delete this[childUserID];
    },

    /**
     * Reset the Parent dashboard store to its initial state
     */
    reset() {
      this.children = undefined;
    }
  }
});
